import { useMovementPageData } from '#src/app/pages/movement/pageContext';

type Result = ModelHookResult<{
	imgHref?: string | null;
}>;

export function useImageAttribution(): Result {
	const {
		data: {
			movement: { photo },
		},
	} = useMovementPageData();

	return {
		data: {
			imgHref: photo?.petitionMedium.url || null,
		},
	};
}
